import Virtual from '@core/models/games/Virtual';
import DateUtils from '@core/utils/date/DateUtils';
import { routeNames } from '@src/app/router';

interface TimeSpan {
    startDate: Date;
    endDate: Date;
}

interface TimeSpanParamsFactory {
    luckysix: (timeSpan: TimeSpan) => string;
    luckyx: (timeSpan: TimeSpan) => string;
    greyhound: (timeSpan: TimeSpan) => string;
    vgreyhound: (timeSpan: TimeSpan) => string;
    vto: (timeSpan: TimeSpan) => string;
    nextsix: (timeSpan: TimeSpan) => string;
    vms: (timeSpan: TimeSpan) => string;
    vhorse: (timeSpan: TimeSpan) => string;
    'sb-vf': (timeSpan: TimeSpan) => string;
}

const create24HourTimeSpan = (date: Date) => {
    const startDate = DateUtils.toStartOfDay(date);
    const endDate = DateUtils.addDays(1, startDate);
    return { startDate, endDate };
};

const createISOParams = ({ startDate, endDate }: TimeSpan) => `${startDate.toISOString()}/${endDate.toISOString()}`;
const createTimeStampParams = ({ startDate, endDate }: TimeSpan) => `${startDate.getTime()}/${endDate.getTime()}`;
const createTimeStampParamsShort = ({ startDate, endDate }: TimeSpan) =>
    `${startDate.getTime() / 1000}/${endDate.getTime() / 1000}`;

const timeSpanParamsFactory = {
    luckysix: createTimeStampParams,
    luckyx: createISOParams,
    greyhound: createISOParams,
    vgreyhound: createISOParams,
    vto: createISOParams,
    nextsix: createISOParams,
    vms: createISOParams,
    vhorse: createISOParams,
    'sr-vto': createISOParams,
    'sb-vf': createTimeStampParams,
    'greyhound##RETAIL': createTimeStampParamsShort,
    'luckysix##RETAIL': createTimeStampParamsShort,
} as TimeSpanParamsFactory;

export default (parentStorePath: string) => ({
    namespaced: true,
    getters: {
        selectedDate(state: any, getters: any, rootState: any, rootGetters: any) {
            return rootGetters[`${parentStorePath}/selectedDate`];
        },
        timeWindow(state: any, getters: any) {
            const selectedDate = getters.selectedDate;
            return create24HourTimeSpan(selectedDate);
        },
        IFrameUrl(state: {}, getters: any, rootState: any, rootGetters: any) {
            return (game: Virtual) => {
                let resultsPath = 'results';

                if (rootGetters['navigation/route'].name === routeNames.virtualShopsResults) {
                    resultsPath = 'results-retail';
                }
                let paramsCreator = timeSpanParamsFactory[game.redirectUrl as keyof TimeSpanParamsFactory];
                if (!paramsCreator) {
                    paramsCreator = createTimeStampParams;
                }
                const timeParams = paramsCreator((getters.timeWindow));
                let url;

                if (game.additionalParams) {
                    const urlParts = game.additionalParams.split('?');
                    url = `${urlParts[0]}${resultsPath}/${timeParams}?${urlParts[1]}`;
                    // cannot deduct this from game data
                    if (game.redirectUrl === 'betradar-virtual-football') {
                        url = `${url}&results=true`;
                    }
                } else if (game.redirectUrl === 'roulette-retail') {
                    const { startDate, endDate } = getters.timeWindow;
                    const date = DateUtils.toString(getters.timeWindow.startDate, 'YYYYMMDD');
                    url = `https://roulette-web.7platform.net/results/superbet?dateFrom=${date}&dateTo=${date}`;
                } else {
                    let redirectUrl = game.redirectUrl.replace('##RETAIL', '');
                    if (redirectUrl === 'sr-vto') {
                        redirectUrl = 'vto';
                    }
                    url = `${game.checkOriginUrl}/#/${redirectUrl}/${resultsPath}/${timeParams}`;
                }
                return url;
            };
        }
    },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/results/virtual.ts